import { render, staticRenderFns } from "./RecentUpdatedInvoices.vue?vue&type=template&id=40d78524"
import script from "./RecentUpdatedInvoices.vue?vue&type=script&lang=js"
export * from "./RecentUpdatedInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports